import Enrollment from '@/models/Enrollment';

export function sortEnrollmentsById(enrollments: Enrollment[]) {
  return enrollments.sort((a, b) => a.student.id - b.student.id);
}
